export default __webpack_public_path__ + "d5dc2a22887368ae12d5149ae0885b18.png";